import script from "./TextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=ts"

import "./TextInput.vue?vue&type=style&index=0&id=5c287e90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c287e90"]])

export default __exports__